<template>
  <svg
    width="71"
    height="52"
    viewBox="0 0 71 52"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="71" height="52" fill="white" />
    <path
      opacity="0.8"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M56.5129 6.13867C56.5129 7.9336 55.0533 9.38867 53.2527 9.38867C51.4522 9.38867 49.9925 7.9336 49.9925 6.13867C49.9925 4.34375 51.4522 2.88867 53.2527 2.88867C55.0533 2.88867 56.5129 4.34375 56.5129 6.13867ZM55.4262 26.3609C55.4262 38.7259 45.3709 48.7498 32.967 48.7498C20.5631 48.7498 10.5078 38.7259 10.5078 26.3609C10.5078 13.9959 20.5631 3.97201 32.967 3.97201C45.3709 3.97201 55.4262 13.9959 55.4262 26.3609ZM59.9542 12.6387C60.8545 12.6387 61.5843 11.9111 61.5843 11.0137C61.5843 10.1162 60.8545 9.38867 59.9542 9.38867C59.054 9.38867 58.3241 10.1162 58.3241 11.0137C58.3241 11.9111 59.054 12.6387 59.9542 12.6387Z"
      fill="url(#paint0_radial_410_32609)"
    />
    <path
      d="M51.3164 35.8125L23.8631 38.9725V41.3062L51.3164 38.1861V35.8125Z"
      fill="url(#paint1_radial_410_32609)"
    />
    <path
      d="M51.9491 36.25L25.6842 39.5L53.2148 36.8409L51.9491 36.25Z"
      fill="url(#paint2_radial_410_32609)"
    />
    <path
      d="M52.1682 37.334L38.723 38.7784L52.4883 37.6229L52.1682 37.334Z"
      fill="url(#paint3_radial_410_32609)"
    />
    <path
      d="M23.5469 38.919L7.45354 30.334V32.7346L23.5469 41.3068V38.919Z"
      fill="url(#paint4_radial_410_32609)"
    />
    <path
      d="M35.127 27.084L7.42761 30.334L23.678 39.1162L51.0781 35.8132L35.127 27.084Z"
      fill="url(#paint5_radial_410_32609)"
    />
    <path
      d="M7.93553 31.818L23.872 40.2233L6.94601 32.0988L7.93553 31.818Z"
      fill="url(#paint6_radial_410_32609)"
    />
    <path
      d="M35.4311 25.6387L7.24752 30.9131L23.9396 39.722L51.4414 34.4476L35.4311 25.6387Z"
      fill="url(#paint7_radial_410_32609)"
    />
    <path
      d="M8.15107 31.0556L23.5465 39.1806L50.7148 34.4861L34.4138 29.25L8.15107 31.0556Z"
      fill="url(#paint8_linear_410_32609)"
    />
    <path
      d="M35.1404 19.5C35.1404 19.5 27.0192 25.3489 20.8317 27.8056C15.6298 29.8709 7.60977 30.875 7.60977 30.875L23.5485 38.8194C23.5485 38.8194 32.6241 37.3314 37.6905 35.2794C43.8188 32.7974 51.4414 22.9306 51.4414 22.9306L35.1404 19.5Z"
      fill="url(#paint9_radial_410_32609)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.7021 31.1984L24.5461 36.7992L24.5464 36.7994L24.5465 36.7994L24.5467 36.7994L24.5474 36.7993C25.0917 36.6918 25.6449 36.5871 26.2057 36.4809C29.9737 35.7679 34.0823 34.9903 38.0968 32.8532L23.7731 28.0402L23.7726 28.0401C23.7733 28.0403 23.7735 28.0403 23.7731 28.0402C23.7729 28.0402 23.7725 28.0402 23.772 28.0403C23.7711 28.0403 23.77 28.0405 23.7688 28.0408C23.7679 28.0411 23.767 28.0414 23.766 28.0418C19.9739 29.7747 16.7381 30.4802 12.7056 31.1943C12.7046 31.1945 12.7036 31.1947 12.7028 31.1949C12.7033 31.1926 12.7039 31.1909 12.7044 31.1898C12.7045 31.1895 12.7046 31.1893 12.7047 31.1892C12.7049 31.1889 12.7049 31.1889 12.7047 31.1892C12.7045 31.1895 12.704 31.1901 12.7033 31.1909C12.7024 31.1918 12.7013 31.1929 12.6999 31.194C12.699 31.1948 12.698 31.1954 12.6972 31.1959C12.6954 31.1949 12.6944 31.1942 12.6939 31.1939C12.6936 31.1937 12.6935 31.1936 12.6935 31.1936C12.6935 31.1936 12.6938 31.1939 12.6945 31.1945C12.695 31.195 12.6956 31.1957 12.6963 31.1965C12.6953 31.197 12.6952 31.197 12.6963 31.1966C12.6963 31.1966 12.6963 31.1966 12.6964 31.1966C12.6969 31.1972 12.6974 31.1978 12.6979 31.1985C12.6988 31.1997 12.6995 31.2009 12.7002 31.202C12.7004 31.2025 12.7006 31.2029 12.7008 31.2033C12.7023 31.2062 12.7023 31.2073 12.7021 31.2061C12.7019 31.2047 12.7017 31.202 12.7021 31.1984ZM12.6976 31.1962C12.6988 31.1958 12.7004 31.1954 12.7028 31.1949C12.7025 31.1958 12.7023 31.1969 12.7022 31.198C12.7022 31.1982 12.7021 31.1983 12.7021 31.1984L12.7019 31.1983C12.7002 31.1975 12.6988 31.1968 12.6976 31.1962ZM24.2356 37.4518C24.3767 37.5185 24.5351 37.538 24.6883 37.5077C25.2246 37.4018 25.773 37.2981 26.3314 37.1926C30.1191 36.4769 34.3728 35.673 38.5176 33.4478C39.0571 33.1581 38.9723 32.3853 38.3917 32.1902L24.004 27.3557C23.8272 27.2963 23.6337 27.3078 23.4641 27.3853C19.7568 29.0794 16.5933 29.7723 12.5789 30.4832C11.8825 30.6065 11.7524 31.5487 12.3914 31.8509L24.2356 37.4518Z"
      fill="#DCE2EE"
    />
    <path
      d="M9.96428 30.6949L23.5485 39.181C36.406 35.748 44.3776 30.6949 48 25.0977L27.8954 27.4449C20.8872 28.9573 19.0362 29.6435 9.96428 30.6949Z"
      fill="url(#paint10_linear_410_32609)"
    />
    <path
      d="M30.4322 19.8618C30.4322 19.8618 26.2663 20.9451 19.3837 22.9312C14.0052 24.4833 6.70512 18.959 6.70512 18.959L22.2816 20.9451C22.2816 20.9451 30.7739 30.4051 36.2425 30.4051C41.6618 30.4051 48.3633 24.1951 48.3633 24.1951L30.4322 19.8618Z"
      fill="url(#paint11_radial_410_32609)"
    />
    <path
      d="M36.5761 23.8235C36.891 23.7036 36.8844 23.2575 36.5663 23.1463C34.0832 22.278 32.4955 21.7444 29.7936 20.7943C29.7384 20.7748 29.6784 20.7687 29.6205 20.7771L28.5977 20.924C28.225 20.9776 28.1715 21.492 28.5251 21.6207L35.4739 24.1487C35.5559 24.1785 35.6459 24.1779 35.7274 24.1468L36.5761 23.8235Z"
      fill="url(#paint12_linear_410_32609)"
    />
    <path
      d="M36.5761 23.8235C36.891 23.7036 36.8844 23.2575 36.5663 23.1463C34.0832 22.278 32.4955 21.7444 29.7936 20.7943C29.7384 20.7748 29.6784 20.7687 29.6205 20.7771L28.5977 20.924C28.225 20.9776 28.1715 21.492 28.5251 21.6207L35.4739 24.1487C35.5559 24.1785 35.6459 24.1779 35.7274 24.1468L36.5761 23.8235Z"
      fill="url(#paint13_radial_410_32609)"
    />
    <path
      d="M32.4647 24.3401C32.7731 24.2243 32.7787 23.7913 32.4733 23.6677L27.63 21.7062C27.5677 21.681 27.4995 21.6736 27.4332 21.6848L26.2415 21.886C25.8829 21.9465 25.8274 22.4372 26.1636 22.5757L31.276 24.6826C31.361 24.7176 31.4561 24.7191 31.5421 24.6868L32.4647 24.3401Z"
      fill="url(#paint14_linear_410_32609)"
    />
    <path
      d="M32.4647 24.3401C32.7731 24.2243 32.7787 23.7913 32.4733 23.6677L27.63 21.7062C27.5677 21.681 27.4995 21.6736 27.4332 21.6848L26.2415 21.886C25.8829 21.9465 25.8274 22.4372 26.1636 22.5757L31.276 24.6826C31.361 24.7176 31.4561 24.7191 31.5421 24.6868L32.4647 24.3401Z"
      fill="url(#paint15_radial_410_32609)"
    />
    <path
      d="M43.1087 25.0981C43.1087 25.5967 42.1356 26.0009 40.9352 26.0009C39.7348 26.0009 38.7617 25.5967 38.7617 25.0981C38.7617 24.5995 39.7348 24.1953 40.9352 24.1953C42.1356 24.1953 43.1087 24.5995 43.1087 25.0981Z"
      fill="url(#paint16_radial_410_32609)"
    />
    <path
      d="M6.70402 18.959C6.70402 18.959 11.2299 22.0114 14.3111 23.6534C21.5913 27.5331 35.6836 30.334 35.6836 30.334C28.9821 27.6257 26.8086 25.459 22.2805 20.9451L6.70402 18.959Z"
      fill="url(#paint17_radial_410_32609)"
    />
    <defs>
      <radialGradient
        id="paint0_radial_410_32609"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(52.8905 -9.20855) rotate(115.508) scale(69.8193 69.9573)"
      >
        <stop stop-color="#EAEEF9" />
        <stop offset="1" stop-color="#A3B1D1" />
      </radialGradient>
      <radialGradient
        id="paint1_radial_410_32609"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(25.2831 43.834) rotate(-20.4713) scale(30.6934 10.8181)"
      >
        <stop stop-color="#D5DDEA" />
        <stop offset="1" stop-color="#F5F6FB" />
      </radialGradient>
      <radialGradient
        id="paint2_radial_410_32609"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(33.1926 58.5938) rotate(-122.882) scale(39.1841 45.4023)"
      >
        <stop stop-color="#DDE3F0" />
        <stop offset="1" stop-color="white" />
      </radialGradient>
      <radialGradient
        id="paint3_radial_410_32609"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(57.0767 37.334) rotate(-155.397) scale(39.5514 38.2427)"
      >
        <stop stop-color="#DDE3F0" />
        <stop offset="1" stop-color="white" />
      </radialGradient>
      <radialGradient
        id="paint4_radial_410_32609"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(21.9639 36.4286) rotate(159.263) scale(22.568 20.2316)"
      >
        <stop stop-color="#D5DDEA" />
        <stop offset="1" stop-color="#DFE4EC" />
      </radialGradient>
      <radialGradient
        id="paint5_radial_410_32609"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(34.9582 37.7368) rotate(-8.62586) scale(25.2809 26.9904)"
      >
        <stop stop-color="#DDE3F0" />
        <stop offset="1" stop-color="white" />
      </radialGradient>
      <radialGradient
        id="paint6_radial_410_32609"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(13.3835 56.1914) rotate(-47.7448) scale(34.8556 33.2541)"
      >
        <stop stop-color="#DDE3F0" />
        <stop offset="1" stop-color="white" />
      </radialGradient>
      <radialGradient
        id="paint7_radial_410_32609"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(24.273 36.6526) rotate(-24.1285) scale(58.7447 38.0306)"
      >
        <stop stop-color="#EDF0F6" />
        <stop offset="1" stop-color="#FAFBFD" />
      </radialGradient>
      <linearGradient
        id="paint8_linear_410_32609"
        x1="80.0567"
        y1="18.7778"
        x2="27.8687"
        y2="63.7713"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.33856" stop-color="white" stop-opacity="0" />
        <stop offset="1" stop-color="#A3B1D1" />
      </linearGradient>
      <radialGradient
        id="paint9_radial_410_32609"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(44.5588 24.9167) rotate(135.09) scale(41.9422 27.2094)"
      >
        <stop stop-color="#EDF0F6" />
        <stop offset="1" stop-color="#FAFBFD" />
      </radialGradient>
      <linearGradient
        id="paint10_linear_410_32609"
        x1="80.0587"
        y1="18.7782"
        x2="-3.30854"
        y2="69.204"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.0781974" stop-color="white" stop-opacity="0" />
        <stop offset="1" stop-color="#A3B1D1" />
      </linearGradient>
      <radialGradient
        id="paint11_radial_410_32609"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(-4.94212 36.3608) rotate(-17.7299) scale(57.6748 37.3205)"
      >
        <stop stop-color="#EDF0F6" />
        <stop offset="1" stop-color="#FAFBFD" />
      </radialGradient>
      <linearGradient
        id="paint12_linear_410_32609"
        x1="47.2302"
        y1="8.33128"
        x2="35.0974"
        y2="31.8866"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#D3DAE9" />
        <stop offset="1" stop-color="#D9D9D9" />
      </linearGradient>
      <radialGradient
        id="paint13_radial_410_32609"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(53.5512 2.01184) rotate(136.762) scale(45.1185 44.3119)"
      >
        <stop stop-color="#A3B1D1" />
        <stop offset="1" stop-color="white" />
      </radialGradient>
      <linearGradient
        id="paint14_linear_410_32609"
        x1="44.5334"
        y1="9.66982"
        x2="32.6104"
        y2="32.6912"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#D3DAE9" />
        <stop offset="1" stop-color="#D9D9D9" />
      </linearGradient>
      <radialGradient
        id="paint15_radial_410_32609"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(50.6915 3.47935) rotate(136.605) scale(44.0696 43.2958)"
      >
        <stop stop-color="#A3B1D1" />
        <stop offset="1" stop-color="white" />
      </radialGradient>
      <radialGradient
        id="paint16_radial_410_32609"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(43.1087 25.3802) rotate(-180) scale(12.0446 5.00289)"
      >
        <stop stop-color="#A3B1D1" />
        <stop offset="1" stop-color="white" />
      </radialGradient>
      <radialGradient
        id="paint17_radial_410_32609"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(23.9106 17.6951) rotate(152.154) scale(23.9664 23.9242)"
      >
        <stop stop-color="#DDE2EE" />
        <stop offset="1" stop-color="#CBD3E5" />
      </radialGradient>
    </defs>
  </svg>
</template>
